import React, {Component} from 'react';
import styles from '../css/Details_Edit_Hem.module.css';

class Details_Edit_Hem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            TARGET_TYPE: this.props.data.TARGET_TYPE_TM13,
            TARGET: this.props.data.TARGET_FLAG_TM13,
            PREV_TARGET_TYPE: this.props.data.TARGET_TYPE_TM13,
            PREV_TARGET: this.props.data.TARGET_FLAG_TM13,
            REQUEST_NOTE: null,
            changed: {}
        };
    }

    firstCapital(str) {
        if (str !== undefined) {
            return str.toLowerCase().replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();})
        }
        return "";
    }

    render() {
        return (
            <div>
                <div className={styles.title}>
                    <div></div>
                    <div>Edit HEM</div>
                    <div className={styles.close} onClick={() => {
                        this.props.close()
                    }}><i className="fas fa-times"></i></div>
                </div>
                <div className={styles.body}>
                    <div className={styles.required}>REQUIRED FIELD *</div>
                    <div className={styles.middlerow}>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>TARGET TYPE</div>
                            <input value={this.state.TARGET_TYPE !== -1 ? this.state.TARGET_TYPE : "-1"} onChange={(event) => {
                                let temp = this.state.changed;
                                if (this.state.PREV_TARGET_TYPE !== event.target.value) {
                                    if (event.target.value === "-1") {
                                        temp.TARGET_TYPE = "";
                                    }
                                    else {
                                        temp.TARGET_TYPE = event.target.value;
                                    }
                                    this.setState({changed: temp});
                                }
                                else {
                                    delete temp.TARGET_TYPE;
                                    this.setState({changed: temp});
                                }
                                if (event.target.value === "-1") {
                                    this.setState({TARGET_TYPE: ""})
                                }
                                else {
                                    this.setState({TARGET_TYPE: event.target.value})
                                }
                            }} />
                        </div>
                        <div className={styles.set}>
                            <div className={styles.inputTitle}>TARGET</div>
                                <input value={this.state.TARGET !== -1 ? this.state.TARGET : "-1"} onChange={(event) => {
                                let temp = this.state.changed;
                                if (this.state.PREV_TARGET !== event.target.value) {
                                    if (event.target.value === "-1") {
                                        temp.TARGET = "";
                                    }
                                    else {
                                        temp.TARGET = event.target.value;
                                    }
                                    this.setState({changed: temp});
                                }
                                else {
                                    delete temp.TARGET;
                                    this.setState({changed: temp});
                                }
                                if (event.target.value === "-1") {
                                    this.setState({TARGET: ""})
                                }
                                else {
                                    this.setState({TARGET: event.target.value})
                                }
                            }} />
                        </div>
                    </div>

                    <div className={styles.set}>
                        <div className={styles.inputTitle}>REVISION REASON</div>
                        <input value={this.state.REQUEST_NOTE} onChange={(event) => {
                                this.setState({REQUEST_NOTE: event.target.value})
                        }} />
                    </div>

                    <div className={styles.buttonRow}>
                        <div id={styles.cancel} onClick={() => {
                            this.props.close();
                        }}>CANCEL</div>
                        <div className={this.state.Wiggle && this.state.Wiggle !== undefined ? styles.Wiggle : ""} id={styles.submit} onClick={() => {
                            if (Object.keys(this.state.changed).length > 0) {
                                let temp = this.state.changed
                                temp.REQUEST_TYPE = "Targeting Exercise Submit"
                                temp.REQUEST_NOTE = this.state.REQUEST_NOTE
                                this.props.submit(temp);
                            }
                            else {
                                this.setState({
                                    Wiggle: true
                                })
                                setTimeout(() => {
                                    this.setState({Wiggle: false})
                                }, 500);
                            }
                        }}>SUBMIT</div>
                    </div>

                </div>
            </div>
        )
    }

}

export default Details_Edit_Hem;
